// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__qr0e6","labelText":"style_labelText__02g7J","textArea":"style_textArea__q2Fkg"};